export default __webpack_public_path__ + "static/media/Ltst-1.54d25b29.jpg";